export default function Manip() {
  return (
    <>
      <p align="left">
        <a class="1" href="/">
          main
        </a>
        {' > '}
        <a class="1" href="/art">
          art
        </a>
        {' > '}
        <a class="1" href="/manip">
          manipulation
        </a>
      </p>
      <table border="0" cellspacing="5" cellpadding="2">
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/manip/blooded.jpg" target="_blank">
                <img
                  src="/assets/manip/blooded_sm.jpg"
                  width="76"
                  height="100"
                />
                <br />
                Blooded
              </a>
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/manip/chrono.jpg" target="_blank">
                <img
                  src="/assets/manip/chrono_sm.jpg"
                  width="69"
                  height="100"
                />
                <br />
                Chrono
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/darknessembracesme.jpg" target="_blank">
                <img
                  src="/assets/manip/darknessembracesme_sm.jpg"
                  width="87"
                  height="100"
                />
                <br />
                Darkness Embraces Me
              </a>{' '}
            </div>
          </td>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/decay.jpg" target="_blank">
                <img src="/assets/manip/decay_sm.jpg" width="59" height="100" />
                <br />
                Decay
              </a>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/manip/depression_room_2.jpg" target="_blank">
                <img
                  src="/assets/manip/depression_room_2_sm.jpg"
                  width="79"
                  height="100"
                />
                <br />
                Depression Room 2{' '}
              </a>
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/manip/depression_room_3.jpg" target="_blank">
                <img
                  src="/assets/manip/depression_room_3_sm.jpg"
                  width="133"
                  height="100"
                />
                <br />
                Depression Room 3{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/manip/dreams01.jpg" target="_blank">
                <img
                  src="/assets/manip/dreams01_sm.jpg"
                  width="97"
                  height="100"
                />
                <br />
                Dream Shattered Away
              </a>{' '}
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/manip/evolution.jpg" target="_blank">
                <img
                  src="/assets/manip/evolution_sm.jpg"
                  width="105"
                  height="100"
                />
                <br />
                Evolution
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/fragmentsofmemories.jpg" target="_blank">
                <img
                  src="/assets/manip/fragmentsofmemories_sm.jpg"
                  width="63"
                  height="100"
                />
                <br />
                Fragments of Memories
              </a>{' '}
            </div>
          </td>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/id.jpg" target="_blank">
                <img src="/assets/manip/id_sm.jpg" width="54" height="100" />
                <br />
                Id
              </a>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/manip/myst.jpg" target="_blank">
                <img src="/assets/manip/myst_sm.jpg" width="133" height="100" />
                <br />
                Myst
              </a>
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/manip/poetry.jpg" target="_blank">
                <img
                  src="/assets/manip/poetry_sm.jpg"
                  width="100"
                  height="100"
                />
                <br />
                Poetry Kills Me{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/manip/powersurge.jpg" target="_blank">
                <img
                  src="/assets/manip/powersurge_sm.jpg"
                  width="133"
                  height="100"
                />
                <br />
                Power Surge{' '}
              </a>
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/manip/rotting.jpg" target="_blank">
                <img
                  src="/assets/manip/rotting_sm.jpg"
                  width="133"
                  height="100"
                />
                <br />
                Rotting
              </a>
            </div>
          </td>
        </tr>
        <tr>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/rotting2.jpg" target="_blank">
                <img
                  src="/assets/manip/rotting2_sm.jpg"
                  width="79"
                  height="100"
                />
                <br />
                Rotting 2{' '}
              </a>
            </div>
          </td>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/siameseduality.jpg" target="_blank">
                <img
                  src="/assets/manip/siameseduality_sm.jpg"
                  width="133"
                  height="100"
                />
                <br />
                Siamese Duality{' '}
              </a>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/manip/stonefloor.jpg" target="_blank">
                <img
                  src="/assets/manip/stonefloor_sm.jpg"
                  width="133"
                  height="100"
                />
                <br />
                Stone Floor{' '}
              </a>
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/manip/torturedsouli.jpg" target="_blank">
                <img
                  src="/assets/manip/torturedsouli_sm.jpg"
                  width="84"
                  height="100"
                />
                <br />
                Tortured Soul
              </a>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td width="150">
            <div align="center">
              <a href="/assets/manip/torturedsoulii.jpg" target="_blank">
                <img
                  src="/assets/manip/torturedsoulii_sm.jpg"
                  width="133"
                  height="100"
                />
                <br />
                Tortured Soul II{' '}
              </a>
            </div>
          </td>
          <td width="150">
            <div align="center">
              <a href="/assets/manip/torturedsouliv.jpg" target="_blank">
                <img
                  src="/assets/manip/torturedsouliv_sm.jpg"
                  width="80"
                  height="100"
                />
                <br />
                Tortured Soul IV - The Beholder
              </a>{' '}
            </div>
          </td>
        </tr>
        <tr>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/waiting_for_me.jpg" target="_blank">
                <img
                  src="/assets/manip/waiting_for_me_sm.jpg"
                  width="133"
                  height="100"
                />
                <br />
                Waiting for Me{' '}
              </a>
            </div>
          </td>
          <td width="150" align="center">
            <div align="center">
              <a href="/assets/manip/where_to_2.jpg" target="_blank">
                <img
                  src="/assets/manip/where_to_2_sm.jpg"
                  width="77"
                  height="100"
                />
                <br />
                Where To
              </a>
            </div>
          </td>
        </tr>
      </table>
    </>
  );
}
